<div
  [attr.data-test]="'scroll-to-top-btn'"
  [class.visible]="windowScrolled"
  (click)="scrollToTop()"
  class="scroll scroll-button box-shadow-tool-tip">
  <eop-icon [identifier]="'arrow-up-outlined'" [tooltip]="tooltip"></eop-icon>
</div>
